import React, { Component } from "react";
import "./SiteWeatherManagement.css";
import $ from "jquery";
import ReactPaginate from "react-paginate";
import OutsideClickHandler from "react-outside-click-handler";
import { Row, Col } from "react-bootstrap";
import SitwWeatherModal from "../SiteWeatherModal/SiteWeatherModal";
import { Container } from "@mui/material";
import { NavLink } from "react-router-dom";
class SiteWeatherManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      InitialAccessToken: localStorage.getItem("GlobalAccess"),
      SelectedState: "govtDept@consumer2.com",
      organizationClick: false,
      categoryClick: false,
      districtClick: false,
      statesClick: false,
      adminsClick: false,
      filterList: [],
      farmSites: [],
      categoriesfilterList: [],
      districtsfilterList: [],
      statesfilterList: [],
      adminsfilterList: [],
      pageCount: 1,
      offset: 0,
      perPage: 3,
      currentPage: 0,
      cboUserName: [],
      postCategoryIdVlaue: "",
      subCategoriesList: [],
      copyOfTenders: [],
      contentOwners: [],
      userTypes: ["AssetDeveloper", "Food-Processor"],
      consumerUsers: [],
      weatherModal: false,
      Latitude: "",
      Longitude: "",
      weatherData: {},
      forecastWeatherData:[],
      ApiUserName:"",
      forecastDate:""
    };
    this.handlePageClick = this.handlePageClick.bind(this);
  }

  // This lifecycle method is called when the component is mounted
componentDidMount() {
  // Calls the getUsers method to fetch users after component mount
  this.getUsers();
}

// Fetches users based on different userTypes and updates the state
getUsers() {
  // Iterates through all userTypes and calls the joinClubValues function for each
  for (let i = 0; i < this.state.userTypes.length; i++) {
      this.joinClubValues(this.state.userTypes[i]);
  }
}

// Fetches user data from an API for a given userType
joinClubValues(userTypes) {
  // Sends a GET request to fetch user data based on the provided userType
  fetch(
      `${window.appConfig.allConsumerUsres}${window.appConfig.Relam}${window.appConfig.Relam}${userTypes}`,
      {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.InitialAccessToken,
          },
      }
  )
  .then((res) => res.json()) // Converts response to JSON
  .then((res) => {
      // Filters the users array to find a specific user (NewAssetDeveloper6@gmail.com)
      const getData = res.users.filter((e, index) => {
          return e.username === 'NewAssetDeveloper6@gmail.com';
      });
      
      // Calls a method to fetch content for the specific content owner (Asset Developer)
      this.getContentOwnerContent(getData[0].username);

      // Updates the consumerUsers state by adding the fetched users to the previous list
      this.setState((prevState) => ({
          consumerUsers: [...prevState.consumerUsers, res.users].flatMap(
              (num) => num
          ),
      }));
  })
  .catch((err) => {
      // Logs any error that occurs during the fetch operation
      console.log("err", err);
  });
}

// Toggles the visibility of the content owner dropdown
contentOwnerDropdownClick() {
  $("#AssetDeveloperOwner").toggle();
}

// Fetches farm content for a given content owner (Asset Developer)
getContentOwnerContent(AssetDeveloper) {
  // Updates the state with the selected content owner's username
  this.setState({
      ApiUserName: AssetDeveloper,
  });

  // Sends a GET request to fetch farm site data for the content owner
  fetch(
      `${window.appConfig.weatherUpdate}${window.appConfig.Relam}${AssetDeveloper}/Farm`,
      {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.InitialAccessToken,
          },
      }
  )
  .then((res) => res.json()) // Converts response to JSON
  .then((result) => {
      // Updates the state with the farm sites and calculates the page count for pagination
      this.setState({
          farmSites: result.sites,
          pageCount: Math.ceil(result.sites.length / this.state.perPage),
      });
  })
  .catch((err) => console.log("err", err));

  // Hides the dropdown menu after selecting a content owner
  $("#AssetDevelopers").hide();
}

// Handles both the weather and forecast requests
weatherReportHandler = (params, user) => {
  // Calls methods to handle weather and forecast data
  this.weatherHandler(params, user);
  this.forecastHandler(params, user);
};

// Fetches current weather data for a given location
weatherHandler = (params, user) => {
  // Prepares the data to be sent in the request body
  const data = {
      "lat": params.latitude,
      "long": params.longitude
  };
  const finalData = JSON.stringify(data);

  // Sends a POST request to fetch the weather data
  fetch(
      `http://54.185.221.117:8900/weather/v1/consumer2/consumer2/${user}/current`,
      {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "networkid": "consumer2",
              "orgid": `${user}`,
              "username": `${user}`,
              Authorization: "Bearer " + this.state.InitialAccessToken,
          },
          body: finalData
      }
  )
  .then((res) => res.json()) // Converts response to JSON
  .then((result) => {
      // Updates the state with the weather data
      this.setState({
          weatherData: result.weatherData,
      });
  })
  .catch((err) => {
      // Logs any error that occurs during the fetch operation
      console.log("err", err);
  });

  // Shows the weather modal after the weather data is fetched
  this.setState({
      weatherModal: true,
  });
};

// Fetches forecast data for a given location
forecastHandler = (params, user) => {
  // Prepares the data to be sent in the request body
  const data = {
      "lat": params.latitude,
      "long": params.longitude
  };
  const finalData = JSON.stringify(data);

  // Sends a POST request to fetch the forecast data
  fetch(
      `https://devicestaging.gbrservice.com/weather/v1/consumer2/consumer2/NewAssetDeveloper6@gmail.com/forecast`,
      {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "networkid": "consumer2",
              "orgid": `${user}`,
              "username": `${user}`,
              Authorization: "Bearer " + this.state.InitialAccessToken,
          },
          body: finalData
      }
  )
  .then((res) => res.json()) // Converts response to JSON
  .then((result) => {
      // Updates the state with the forecast data
      this.setState({
          forecastWeatherData: result.weatherData.list,
          weatherModal: true,
      });
  })
  .catch((err) => {
      // Logs any error that occurs during the fetch operation
      console.log("err", err);
  });
};

// Hides the weather modal
hideModalHandler = () => {
  this.setState({
      weatherModal: false,
  });
};

// Handles pagination when a page is clicked
handlePageClick = (e) => {
  // Gets the selected page index and calculates the offset
  const selectedPage = e.selected;
  const offset = selectedPage * this.state.perPage;

  // Updates the state with the selected page and new offset
  this.setState({
      currentPage: selectedPage,
      offset: offset,
  });
};


render() {
  // Destructuring state variables for easy access
  const { farmSites, subCategoriesList, contentOwners, consumerUsers } = this.state;

  /* Filter Functionality: slices farmSites data for pagination */
  const farmSitesFilteredData = farmSites.slice(
    this.state.offset, // Starting point for the page
    this.state.offset + this.state.perPage // Ending point based on perPage
  );

  return (
    <Container
      id="tendersContainer"
      className="container-fluid gbr-engage-container"
    >
      {/* Weather Modal - Displays weather and forecast data */}
      <SitwWeatherModal
        props={this.state.weatherData} // Pass weather data to modal
        Show={this.state.weatherModal} // Modal visibility based on state
        onclicked={this.hideModalHandler} // Method to hide modal
        forecast={this.state.forecastWeatherData} // Pass forecast data to modal
      />

      {/* Dropdown and buttons for content owners and adding farms */}
      <div className="mb-4">
        <div className="dropdown">
          <div className="dropdown homepage-nav-item">
            <div className="navbarRight">
              <button
                className="btn btn-success homepageBtn"
                type="button"
                aria-haspopup="true"
                aria-expanded="false"
                onClick={() => this.contentOwnerDropdownClick()} // Toggles dropdown visibility
              >
                Club Owners
              </button>
            </div>

            {/* Button for adding a farm */}
            <div className="navbarRight">
              <NavLink className="btn btn-success homepageBtn" to="/auth/3/signup">
                Add your Farm
              </NavLink>
            </div>

            {/* Dropdown menu for selecting content owners */}
            <div
              className="dropdown-menu"
              id="AssetDeveloperOwner"
              aria-labelledby="AssetDeveloperOwner"
            >
              {/* Maps over consumerUsers and displays them in the dropdown */}
              {consumerUsers &&
                consumerUsers.map((filter, i) => (
                  <li key={i}>
                    <a
                      className="dropdown-item"
                      role="button"
                      onClick={() =>
                        this.getContentOwnerContent(filter.username) // Fetches content for selected content owner
                      }
                    >
                      {filter.username} {/* Displays username of content owner */}
                    </a>
                  </li>
                ))}
            </div>
          </div>
        </div>
      </div>

      {/* Display farm sites in cards */}
      <div className="adminTendersDiv">
        {farmSitesFilteredData.length > 0 ? (
          <Row className="justify-content-center">
            {/* Maps over filtered farm sites and displays each one */}
            {farmSitesFilteredData.map((site, index) => (
              <Col md={6} lg={4} sm={12} xs={12} className="mb-4" key={index}>
                <div className="community-cards w-100">
                  <div className="bordered-div"></div>
                  <div>
                    <div className="scrollable-container scrollable-container-weather">
                      <div className="community-card-body">
                        <h2 className="mb-2 mt-2">
                          {site.sitename} {/* Site name */}
                          {site.timestamp} {/* Timestamp */}
                        </h2>
                        <p>
                          <b>Site Type: </b>
                          {site.sitetype} {/* Site type */}
                        </p>
                        <p>
                          <b>Latitude: </b>
                          {site.latitude} {/* Latitude */}
                        </p>
                        <p>
                          <b>Longitude: </b>
                          {site.longitude} {/* Longitude */}
                        </p>
                      </div>
                    </div>
                    <div className="community-button-container p-3 px-0 text-center">
                      {/* Button to check weather based on site coordinates */}
                      <button
                        onClick={() => this.weatherReportHandler(site, this.state.ApiUserName)}
                        className={`Formbutton mx-auto d-block ${site.longitude === "null" ? "disabled bt-disabled" : ""}`} 
                        disabled={site.longitude === "null"} // Disable button if longitude is "null"
                        type="submit"
                      >
                        Check Weather
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            ))}

            {/* Pagination Component */}
            <div className="paginationComponent">
              <ReactPaginate
                previousLabel={"<<"}
                nextLabel={">>"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={this.state.pageCount} // Total number of pages
                marginPagesDisplayed={2} // Pages to display at the start and end
                pageRangeDisplayed={5} // Number of page links to display
                onPageChange={this.handlePageClick} // Method to handle page change
                containerClassName={"pagination"} // Class for pagination container
                subContainerClassName={"pages pagination"} // Class for pagination page container
                activeClassName={"active"} // Class for active page
              />
            </div>
          </Row>
        ) : (
          // If no farm sites are found, display a message
          <div className="card">
            <p className="card-body container-heading2">
              <b>Farms Not Found</b>
            </p>
          </div>
        )}
      </div>

      {/* Outside click handler to close dropdowns when clicking outside */}
      <OutsideClickHandler
        onOutsideClick={() => {
          $("#AssetDevelopers").hide(); // Hides Asset Developers dropdown
          $("#AssetDeveloperOwner").hide(); // Hides Asset Developer Owner dropdown
        }}
      ><></></OutsideClickHandler>
      <br />
    </Container>
  );
}

}

export default SiteWeatherManagement;
